<div class="sticky-top mt-2">
    <mat-progress-bar *ngIf="showLoading" mode="indeterminate" [style.display]="showLoading ? 'list-item' : 'none' "></mat-progress-bar>
    <!-- <mat-progress-bar mode="indeterminate" [style.visibility]="showLoading ? 'visible' : 'hidden' "></mat-progress-bar> -->
    <div class="top-bar-flex pt-2" *ngIf="showFilter" style="background: #fcf8fb;">

        <app-text-filter *ngIf="!showLoading" (searchString)="filterItems($event)"  [loadingPagination]="showLoading"></app-text-filter>
        <div class="icon">
            <div *ngIf="showAdd">

                @if(showHDAddMenu){
                    <button mat-icon-button [matMenuTriggerFor]="HDmenu">
                        <mat-icon>add</mat-icon>
                      </button>
                
                      <mat-menu #HDmenu="matMenu">
                
                        <button mat-menu-item (click)="createDocumentFromList()">
                            <mat-icon >format_list_bulleted_add</mat-icon>{{'FORM.huntingDistrictForm.select_fr_list' | translate}}
                        </button>
                        
                        <button mat-menu-item (click)="createDocument()">
                            <mat-icon>list_alt_add</mat-icon>{{ 'FORM.huntingDistrictForm.add_own' | translate }}
                        </button>
                      </mat-menu>
                }@else{
                    <button mat-icon-button (click)="createDocument()">
                        <mat-icon>add</mat-icon>
                    </button>
                }

            </div>
        </div>
    </div>
</div>

<!-- <div *ngIf="!showLoading; else loading"> -->
    <div *ngIf="filteredList$ | async as list; else loading" class="my-2">
        <div *ngIf="list.length > 0; else noItems">
            <div *ngFor="let item of list">
                <app-list-item [data]="item"></app-list-item>
            </div>
        </div>
        <!-- ngfor... -->
        <!-- <app-list-item [data]="data"></app-list-item> -->
    </div>
<!-- </div> -->
<ng-template #loading>
    Loading...
</ng-template>
<ng-template #noItems>
    Keine Items
</ng-template>
